"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpCancelError = void 0;
var genericError_1 = require("./genericError");
var HttpCancelError = /** @class */ (function (_super) {
    __extends(HttpCancelError, _super);
    function HttpCancelError(message, domain) {
        if (domain === void 0) { domain = 'httpApi'; }
        var _this = _super.call(this, { type: 'CancelError', domain: domain, message: message }) || this;
        Object.setPrototypeOf(_this, HttpCancelError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, HttpCancelError);
        }
        else {
            _this.stack = new Error().stack;
        }
        return _this;
    }
    return HttpCancelError;
}(genericError_1.GenericError));
exports.HttpCancelError = HttpCancelError;
//# sourceMappingURL=httpCancelError.js.map